import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Your components
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import EmailJSSetup from './components/EmailJSSetup';
import CookieConsent from './components/CookieConsent'; // ✅ import cookie banner
import BackToTopButton from './components/BacktoTop'; // import back to top button
import PrivacyPolicy from './components/privacy-policy';
import TermsOfService from './components/TermsOfService';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Header />

        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/emailjs-setup" element={<EmailJSSetup />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
          <BackToTopButton />
          
        </main>

        <Footer />

        {/* ✅ Cookie banner always rendered once at the bottom */}
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
  